var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIconBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3031,
    cy: 12.0004,
    r: 11.475,
    fill: "#123051"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09038 11.1052L13.5091 8.89583M13.5112 15.1052L9.09665 12.8979M17.3008 8C17.3008 9.10457 16.4054 10 15.3008 10C14.1962 10 13.3008 9.10457 13.3008 8C13.3008 6.89543 14.1962 6 15.3008 6C16.4054 6 17.3008 6.89543 17.3008 8ZM9.30078 12C9.30078 13.1046 8.40535 14 7.30078 14C6.19621 14 5.30078 13.1046 5.30078 12C5.30078 10.8954 6.19621 10 7.30078 10C8.40535 10 9.30078 10.8954 9.30078 12ZM17.3008 16C17.3008 17.1046 16.4054 18 15.3008 18C14.1962 18 13.3008 17.1046 13.3008 16C13.3008 14.8954 14.1962 14 15.3008 14C16.4054 14 17.3008 14.8954 17.3008 16Z",
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIconBg);
export default __webpack_public_path__ + "static/media/share-icon-bg.b175e5af2a14f0da9a4d96b76dbfc53c.svg";
export { ForwardRef as ReactComponent };